/**
 * main.ts - Entry point for the Boylston Chess Club registration
 * checkout flow. Wires up all modules on DOMContentLoaded.
 */
import { initStepNavigation } from './stepNavigation';
import { initPlayerManagement } from './playerManagement';
import { initUscfSearchModal } from './uscfSearch';
import { initPaymentToggles } from './paymentToggles';
import { initCartCalculations } from './cart';
import { initFormSubmission } from './formSubmission';

// initUscfLookup (uscfLookup.ts) is intentionally not wired up here -
// the name-search modal (uscfSearch.ts) replaced it. Import and call it
// if the ID-lookup flow needs to come back.

document.addEventListener('DOMContentLoaded', () => {
    initStepNavigation();
    initPlayerManagement();
    initUscfSearchModal();
    initPaymentToggles();
    initCartCalculations();
    initFormSubmission();
});